import { getDepartmentByIdRequest } from "../../data/departmentApi";

function getPayloadData(response) {
  if (response?.data && !Array.isArray(response.data)) {
    return response.data;
  }

  if (response?.data?.data && !Array.isArray(response.data.data)) {
    return response.data.data;
  }

  return null;
}

export async function getDepartmentByIdUseCase(id) {
  if (!id) {
    throw new Error("El id es obligatorio.");
  }

  const department = getPayloadData(await getDepartmentByIdRequest(id));

  if (!department) {
    throw new Error("No se pudo cargar el departamento.");
  }

  return department;
}
